<template>
  <div>
    <el-transfer
      v-model="currentChannels"
      :titles="['Available', 'Enabled']"
      :data="handleChannelData"
    ></el-transfer>
  </div>
</template>

<script>
import SocialIcon from '@/components/common/Icons/SocialIcon';
import collect from 'collect.js';

export default {
  name: 'ChannelSelector',
  components: {
    SocialIcon,
  },
  props: {
    channels: {
      type: Array,
    },
    createChannels: {
      type: Array,
    },
    selectedChannels: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    currentChannels: {
      get() {
        return this.selectedChannels;
      },
      set(newSelectedChannels) {
        this.$emit('onSelectedChannelsChanged', newSelectedChannels);
      },
    },
    createChannelData() {
      const collection = collect(this.createChannels);
      const filteredChannels = collection.filter(value => value.channelTypeTitle !== 'Survey');
      return filteredChannels.all().map(channel => ({
        key: channel.id,
        label: `${channel.handle} (${channel.channelTypeTitle})`,
        disabled: false,
      }));
    },
    channelData() {
      return this.channels.map(({ channel }) => ({
        key: channel.id,
        label: `${channel.handle} (${channel.channelTypeTitle})`,
        disabled: false,
      }));
    },
    handleChannelData() {
      if (typeof this.channels !== 'undefined' && this.channels) {
        return this.channelData;
      }
      return this.createChannelData;
    },
  },
};
</script>
<style scoped>
div >>> .el-transfer-panel {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// ChannelSelect.vue?20c615f6